import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { functions } from "@poseidon/firebase/firebase";
import { useCallback, useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";

export const useFetchCalculations = () => {
  const [loading, setLoading] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "fetchCalculations"
  );

  const run = useCallback(
    async (sailorId: string) => {
      try {
        setLoading(true);
        const response = (await executeCallable({ sailorId })) as any;
        setToast("Fetched Calculations");
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        } else {
          setError("Unknown error");
        }
      }
      setLoading(false);
    },
    [executeCallable, setError, setToast]
  );

  return { run, loading };
};
